<template>
  <summary-detail ref="detail" class="summary-detail-order dashboard-table"
                  :type="`<span style='font-size: 2rem;color: #E03F3D'>${$route.query.sale_name}</span> 客户拓新详情`"
                  :year="$route.query.year"
                  :month="$route.query.month" layout="order">
    <template v-slot:append>
      <i class="el-icon-refresh i-handel" @click="init"/>
    </template>
    <el-row>
      <el-col :span="20" style="text-align: left;margin-bottom: 10px;padding-left: 1px">
            <span style="font-size: 1.1rem;font-weight: 600">
              合计&nbsp;&nbsp;&nbsp;&nbsp;
              客户拓新数量：<span class="order-num">{{ sum.count }}</span>
                &nbsp;&nbsp;&nbsp;&nbsp;
              订单金额：<span class="money order-money">{{ sum.money|numberFormat }}</span>
              &nbsp;&nbsp;&nbsp;&nbsp;
            </span>
      </el-col>
    </el-row>
    <el-table :data="tableData" border>
      <el-table-column type="index" label="序号" width="60" align="center"/>
      <el-table-column prop="customer_name" label="客户名称" min-width="160" show-tooltip-when-overflow sortable>
        <template slot-scope="scope">
          <div>
                 <span style="padding: 1px 1px; background-color: #FF5722; color: #fff; font-size: 12px;"
                       v-show="scope.row.order_type === 'strike'">冲</span>
            {{ scope.row.customer_name }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="artist_name" label="红人名称" min-width="110" show-tooltip-when-overflow sortable/>
      <el-table-column prop="brand" label="品牌" min-width="80" :sortable="true"/>
      <el-table-column prop="product" label="产品/内容" min-width="100" :show-tooltip-when-overflow="true"/>
      <el-table-column
          prop="payment_account"
          label="含税收入"
          min-width="100" align="right" header-align="center">
        <template slot-scope="scope">
          <span class="money">{{ scope.row.payment_account |numberFormat }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="sale" label="销售" min-width="80" sortable/>
      <el-table-column prop="executor" label="执行" min-width="80" :sortable="true"/>
      <el-table-column prop="exec_timestamp" label="执行时间" width="100" align="center" :sortable="true">
      </el-table-column>
      <el-table-column prop="created_timestamp" label="下单时间" width="100" align="center" :sortable="true">
      </el-table-column>
      <el-table-column prop="order_no" label="订单编号" min-width="140" :show-tooltip-when-overflow="true">
        <template slot-scope="scope">
          <to-order-detail :order="scope.row"/>
        </template>
      </el-table-column>
    </el-table>
  </summary-detail>
</template>

<style scoped>

</style>
<script>
import SummaryDetail from "./components/Detail.vue";
import {getOrdersNewCustomer} from "../../api/home";
import ToOrderDetail from "@/views/adOrder/components/ToDetail";

export default {
  components: {SummaryDetail, ToOrderDetail},
  data() {
    return {
      tableData: [],
      sum: {
        money: 0,
        count: 0
      }
    }
  },
  created() {
    this.init()
  },
  methods: {
    async init() {
      const params = this.$route.query
      params.sale_ids = [params.sale_id]
      const {data} = await getOrdersNewCustomer(params)
      this.tableData = data
      let count = 0
      let money = 0
      const customer_ids = []
      data.map(_ => {
        if (_.customer_id) {
          customer_ids.push(_.customer_id)
        }
        money += Number(_.payment_account);
      })
      count = Array.from(new Set(customer_ids)).length;
      this.sum = {money, count}
    }
  }
}
</script>
